<template>
  <div>
    <b-tabs class="w-tabs">
      <b-tab :title="language.name" :key="language.code" v-for="language in languages">
        <CompetentAuthorityForm v-if="!loading" :onlyRead="onlyRead" :language="language.code" @success="setData" :header-id="cloneHeaderId" :detail="getDetailByLanguage(language.code)"/>
      </b-tab>
    </b-tabs>
  </div>

</template>

<script>


import CompetentAuthorityForm from "@/components/competentAuthority/CompetentAuthorityForm.vue";
import {fetchCompetentAuthority} from "@/services/competentAuthority";
import {cloneDeep} from "lodash";

export default {
  name: "CompetentAuthorityLanguageWrapper",
  props: {
    header: {
      type: Object
    },
    onlyRead: {
      type: Boolean,
      default: false
    }
  },
  components: {CompetentAuthorityForm},
  data() {
    return {
      languages: [
        { code: 'bs', name: this.$t('BA') },
        { code: 'hr', name: this.$t('HR')  },
        { code: 'sr', name: this.$t('SR')  },
      ],
      selectedLanguage: 'bs',
      competentAuthority: null,
      loading: false,
      cloneHeaderId: null
    }
  },
  methods: {
    selectLanguage(language){
      this.selectedLanguage = language;
    },
    setData(header_id) {
      this.loading = true;
      fetchCompetentAuthority(header_id).then((response) => {
        this.competentAuthority = response.data;
        this.cloneHeaderId = response.data.id;
      }).finally(() =>{
        this.loading = false;
      })
    },
    getDetailByLanguage(language) {
      if(this.competentAuthority && this.competentAuthority.details && this.competentAuthority.details.length > 0) {
        return this.competentAuthority.details.find((el) => el.language === language)
      }
      return null;
    }
  },
  async mounted() {
    if(this.header) {
      const { id } = this.header;
      if(id) {
        this.cloneHeaderId = cloneDeep(id);
        await this.setData(id);
      }
    }
  }
}
</script>
<style >
.tab-content {
  border: none;
}
</style>
